import { useState, useEffect } from 'react';
import Navbar from './Navbar';

import { Carousel, Row } from "react-bootstrap";
import EventData from './data/EventData.json';
//import May from './data/May.json';

import 'bootstrap/dist/css/bootstrap.min.css';
import './css/Home.css';


var images = require.context('./images', true);

//var cardTitleStyle={
//  backgroundColor: "#b23850",
//  zIndex: "3",
//};


function Home() {

  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  var today = new Date();
  var monthNumber = today.getMonth();
  var monthName = monthNames[monthNumber];
  var currentYear = today.getFullYear();
//  console.log("Month Outside " + monthName);

  let dateToday = today.getDate();
//  console.log("Date " + dateToday);


  const [monthlyEvent, setMonthlyEvent] = useState(getRegularEvents());
  const [specialEvent, setSpecialEvents] = useState(getSpecialEvents());
  const [centreEvent, setCentreEvents] = useState(getCentreEvents());

  GetThisMonthThirdSaturday();

  function getRegularEvents() {
    let eventListR = [];
    EventData.forEach((eventItem) => {
      if (eventItem.eventType === 'ME' || eventItem.eventType === 'SE') {
        if (eventItem.eventMonth === monthName && eventItem.eventDate >= dateToday) {
          let dayToday = new Date(eventItem.eventYear, monthNames.indexOf(eventItem.eventMonth), eventItem.eventDate);
          eventItem.eventDay = dayNames[dayToday.getDay()];
          eventListR.push(eventItem);
        }
      }
    });

//    console.log("Event ME " + JSON.stringify(eventListR));
    return eventListR;
  }


  function getSpecialEvents() {
    let eventListS = [];
    EventData.forEach((eventItem) => {
      if (eventItem.eventType === 'SE') {
        if (eventItem.eventYear >= currentYear && monthNames.indexOf(eventItem.eventMonth) == monthNumber && eventItem.eventDate >= dateToday) {
          let dayToday = new Date(eventItem.eventYear, monthNames.indexOf(eventItem.eventMonth), eventItem.eventDate);
          eventItem.eventDay = dayNames[dayToday.getDay()];
          eventListS.push(eventItem);
        }

        if (eventItem.eventYear >= currentYear && monthNames.indexOf(eventItem.eventMonth) > monthNumber) {
          let dayToday = new Date(eventItem.eventYear, monthNames.indexOf(eventItem.eventMonth), eventItem.eventDate);
          eventItem.eventDay = dayNames[dayToday.getDay()];
          eventListS.push(eventItem);
        }

//        console.log("eventItem.eventYear " + eventItem.eventYear);
//        console.log("currentYear " + currentYear);
        if (eventItem.eventYear > currentYear) {
          let dayToday = new Date(eventItem.eventYear, monthNames.indexOf(eventItem.eventMonth), eventItem.eventDate);
          eventItem.eventDay = dayNames[dayToday.getDay()];
          eventListS.push(eventItem);
        }
      }
    });

//    console.log("Event SE " + JSON.stringify(eventListS));
    return eventListS;
  }

  function getCentreEvents() {
    let eventListC = [];
    EventData.forEach((eventItem) => {
      if (eventItem.eventType === 'SLF') {
        eventListC.push(eventItem);
//        console.log("Event C in " + JSON.stringify(eventItem));
      }
      if (eventItem.eventType === 'SLT' || eventItem.eventType === 'SLE') {
//        console.log("eventItem.eventMonth " + monthNames.indexOf(eventItem.eventMonth));
//        console.log("monthNumber " + monthNumber);
//        console.log("eventItem.eventDate " + eventItem.eventDate);
//        console.log("dateToday " + dateToday);
        if (eventItem.eventYear >= currentYear && monthNames.indexOf(eventItem.eventMonth) >= monthNumber && eventItem.eventDate >= dateToday) {
          let dayToday = new Date(eventItem.eventYear, monthNames.indexOf(eventItem.eventMonth), eventItem.eventDate);
          eventItem.eventDay = dayNames[dayToday.getDay()];
          eventListC.push(eventItem);
//          console.log("Event C in " + JSON.stringify(eventItem));
        }
      }
    });

//    console.log("Event C Out " + JSON.stringify(eventListC));
    return eventListC;
  }

  function GetThisMonthThirdSaturday() {

    let dateToday = new Date();
    let countDate = 1;
    dateToday = new Date(dateToday.getFullYear(), dateToday.getMonth(), countDate);
    let countSaturday = 0;

    while (countSaturday < 3) {

      if (dateToday.getDay() === 6) {
        countSaturday++;
      }

      countDate++;
      dateToday = new Date(dateToday.getFullYear(), dateToday.getMonth(), countDate);

    }

//    console.log("Year " + dateToday.getFullYear());
//    console.log("Month " + dateToday.getMonth());
//    console.log("Date " + (countDate - 1).toString());
    let dateSaturday = new Date(dateToday.getFullYear(), dateToday.getMonth(), countDate - 1);
//    console.log("New Date " + dateSaturday.getDate());

    let eventItem = {};
    eventItem.eventMonth = monthName;
    eventItem.eventDate = dateSaturday.getDate();
    eventItem.eventDay = "Saturday";

    let dateCalendar = new Date();
//    console.log("eventItem.eventDate " + eventItem.eventDate);
//    console.log("dateCalendar.getDate() " + dateCalendar.getDate());

    if (eventItem.eventMonth === monthName && eventItem.eventDate >= dateCalendar.getDate()) {
      eventItem.eventType = "ME";
      eventItem.eventName = "මාසික සිල් දිනය (Monthly Sil Day)";
      eventItem.imagePath = "";
      eventItem.imageAltName = "";
      monthlyEvent.push(eventItem);
    }

  }

  function sendEmail() {
    window.open('mailto:temple<temple@dhammadeepa.org.au>?subject=Web Page Inquiry&body=Hi Committee of Management,');
  }

  return (

    <div className="grid gap-0 row-gap-3">

      <div className="p-5">
        <Navbar />
      </div>

      <div className="card-deck ml-2 mr-2 ">

        <div className="card col-md-3 border border-primary border-2 cardStyle">
          <div className="card-header text-center rounded ">
            <h3 className="label display-6">Events in {monthName}</h3>
          </div>

          <ul className="list-group list-group-flush">
            {monthlyEvent.map(eventItemR => (
              <li className="list-group-item" key={eventItemR.eventName}><strong>{eventItemR.eventMonth} {eventItemR.eventDate} ({eventItemR.eventDay})</strong><br />{eventItemR.eventName}</li>
            ))
            }
          </ul>
        </div>

        <div className="card col-md-6 border border-primary border-2 cardStyle">
          <Carousel>
            {centreEvent.map(eventItemC => (
              <Carousel.Item key={eventItemC.imagePath}>
                <img
                  src={images("./" + eventItemC.imagePath)}
                  alt={eventItemC.imageAltName}
                  className="img-fluid"
                />
                <Carousel.Caption>
                  <p>{eventItemC.imageAltName}</p>
                </Carousel.Caption>
              </Carousel.Item>
            ))}
          </Carousel>
          <div className="panel btn-primary">
            <div className="panel-heading text-white text-center"> SCHEDULED STARTING TIMES</div>
            <div className="panel-heading text-white text-center">Dharma Sermons : 8pm ---- Weekend Pooja : 7pm ---- Weekday Pooja : 7pm</div>
          </div>

        </div>

        <div className="card col-md-3 border border-primary border-2 cardStyle">
          <div className="card-header text-center rounded ">
            <h3 className="label display-6">Special Events</h3>
          </div>

          <ul className="list-group list-group-flush">
            {specialEvent.map(eventItemS => (
              <li className="list-group-item" key={eventItemS.eventName}><strong>{eventItemS.eventMonth} {eventItemS.eventDate} ({eventItemS.eventDay})</strong> <br />{eventItemS.eventName}<br />
                {eventItemS.imagePath!=''
                  ? <a href="/events" className="btn border border-primary border-1">More Details</a>
                  : <p></p>
                }
                <hr />
              </li>
            ))
            }
          </ul>

        </div>

      </div>

      <div className="mt-3">
        <div className="card-deck ml-2 mr-2">

          <div className="card border border-primary border-2">
            <figure className="figure">
              <img className="img-fluid" src={images("./ChiefIncumbentThero.jpg")} alt="cap" />
              <figcaption className="figure-caption text-center"><br /><h4>Chief Incumbent Thero</h4></figcaption>
            </figure>
            <div className="card-body">
              <p className="card-text">Most Venerable Akaravita Sangananda Thero, MA <br />Chief Sanganayake of Australia <br />Asgiriya Chapter of Siam Nikaya</p>
              <a href="/venThero" className="btn border border-primary border-1">Learn More</a>
            </div>
          </div>


          <div className="card border border-primary border-2">
            <figure className="figure">
              <img className="img-fluid" src={images("./Committee.jpg")} alt="cap" />
              <figcaption className="figure-caption text-center"><h6>ABN: 14 015 662 668</h6><h4>Management Committee</h4></figcaption>
            </figure>
            <div className="card-body">
              <p className="card-text">Dhammadeepa meditation centres located at Dandenong and Cranbourne are managed by The Buddhist Meditation Association of Victoria. ....</p>
              <a href="/purpose" className="btn border border-primary border-1">Learn More</a>
            </div>
          </div>

          <div className="card border border-primary border-2">
            <figure className="figure">
              <img className="img-fluid" src={images("./SundaySchool.jpg")} alt="cap" />
              <figcaption className="figure-caption text-center"><br /><h4>Sunday School</h4></figcaption>
            </figure>
            <div className="card-body">
              <p className="card-text">Sunday school provides an opportunity for school aged children to learn buddhism and Sinhala language. ...<br /><br /></p>
              <a href="/sundaySchool" className="btn border border-primary border-1">Learn More</a>
            </div>
          </div>

          <div className="card border border-primary border-2">
            <figure className="figure">
              <img className="img-fluid" src={images("./AboutUs.jpg")} alt="cap" />
              <figcaption className="figure-caption text-center"><br /><h4>Contact Us</h4></figcaption>
            </figure>
            <div className="card-body">
              <table className="table">
                <tbody>
                  <tr>
                    <th scope="row">Dandenong</th>
                    <td>+61 3 9794 9492</td>
                  </tr>
                  <tr>
                    <th scope="row">Cranbourne</th>
                    <td>+61 3 9770 7027</td>
                  </tr>
                  <tr>
                    <th scope="row">eMail us</th>
                    <td><button className="btn border border-primary border-1" onClick={sendEmail}>Click here to open<br /> your own email client</button></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>

      </div>

    </div>

  );

}


export default Home;
